import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const AnoMesFinFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='PERIODO FIN' htmlFor='input-anoMesFin' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='anoMesFin'>
          {({ field }) => <Form.InputText {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} id='input-anoMesFin' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(AnoMesFinFormGroup)
